import React from 'react';
import { oneOf, shape, string } from 'prop-types';

import LogoASA from '@/assets/Image/ajaib-asa-gray.png';
import LogoKTI from '@/assets/Image/ajaib-kti-gray.png';
import LogoTTI from '@/assets/Image/ajaib-tti-gray.png';

import { Container, Row, Col } from '../Layout';
import Typography from '../Typography';

const CompanyText = ({
  className, company, placement, style,
}) => {
  const icon = () => {
    switch (company) {
      case 'crypto':
        return <img alt="logo-KTI" src={LogoKTI} height={36} />;
      case 'mf':
        return <img alt="logo-TTI" src={LogoTTI} height={36} />;
      case 'stock':
      default:
        return <img alt="logo-ASA" src={LogoASA} height={36} />;
    }
  };

  const text = () => {
    switch (company) {
      case 'crypto':
        return 'PT Kagum Teknologi Indonesia (Ajaib Kripto) berizin dan diawasi oleh Bappebti';
      case 'mf':
        return 'PT Takjub Teknologi Indonesia (Ajaib Reksadana) berizin dan diawasi oleh OJK';
      case 'stock':
      default:
        return 'PT Ajaib Sekuritas Asia (Ajaib Sekuritas) berizin dan diawasi oleh OJK';
    }
  };

  if (placement === 'vertical') {
    return (
      <Container className={className} style={style}>
        <Row align="center" padding="4px 0px">
          <Col size="auto">{icon()}</Col>
        </Row>
        <Row align="center" padding="4px 0px">
          <Col size="auto">
            <Typography type="label" bold style={{ margin: 0 }} align="center">
              {text()}
            </Typography>
          </Col>
        </Row>
      </Container>
    );
  }

  if (placement === 'horizontal') {
    return (
      <Container className={className} style={style}>
        <Row align="left" padding="16px 8px">
          <Col size="auto">{icon()}</Col>
          <Col size="auto">
            <Typography type="label" bold style={{ margin: 0 }}>
              {text()}
            </Typography>
          </Col>
        </Row>
      </Container>
    );
  }

  return null;
};

CompanyText.propTypes = {
  className: string,
  company: oneOf(['stock', 'mf', 'crypto']),
  placement: oneOf(['vertical', 'horizontal']),
  style: shape({}),
};

CompanyText.defaultProps = {
  className: '',
  company: 'stock',
  placement: 'horizontal',
  style: {},
};

export default CompanyText;
